import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, Circle, LayersControl } from "react-leaflet";
import { Circle as CircleType, LatLngTuple } from "leaflet";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import { OfficesLocationMap } from "src/components/common/functions";
import { useAuthStore } from "src/components/main/authStore";
//--------------------------------------------------------------------------------------------
//locationName, coordsName, location, coords
export default function MapRange({
    coords, 
    accuracy,
    closeIt
}:{
    coords: LatLngTuple, 
    accuracy: number, 
    closeIt: Function
}){
    const user = useAuthStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal 
            width = {"100%"}
            maxWidth = {1000}
            title = {"Map"}
            closeIt = {closeIt}
        >
            <div style = {{height: 600}}>
                <MapContainer
                    center = {user!.coords}
                    zoom = {12}
                    scrollWheelZoom = {true}
                >
                    <LayersControl position = "topright">
                        <LayersControl.BaseLayer name = "Google Maps">
                            <TileLayer
                                attribution = ""
                                url = "https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name = "Google Satellite">
                            <TileLayer
                                attribution = ""
                                url = "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name = "Google Satellite Hybrid" checked>
                            <TileLayer
                                attribution = ""
                                url = "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name = "Google Terrain">
                            <TileLayer
                                attribution = ""
                                url = "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name = "Google Roads">
                            <TileLayer
                                attribution = ""
                                url = "https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name = "Open Street Map">
                            <TileLayer
                                attribution = ""
                                url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                        </LayersControl.BaseLayer>
                        {false?
                        <LayersControl.BaseLayer name = "Black And White">
                            <TileLayer
                                attribution = ""
                                url = "https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
                            />
                        </LayersControl.BaseLayer>
                        :<></>}
                    </LayersControl>
                    {Object.entries(OfficesLocationMap).map(([officeName, officeLocation], officeIndex) => 
                        <Marker
                            key = {officeIndex}
                            position = {officeLocation}
                        >
                            <Popup>
                                {officeName}
                            </Popup>
                        </Marker>
                    )}
                    <Locate
                        flyCoords = {coords}
                        accuracy = {accuracy}
                    />
                </MapContainer>
            </div>
        </Modal>
    )
}
//--------------------------------------------------------------------------------------------
function Locate({
    flyCoords, 
    accuracy
}:{
    flyCoords: LatLngTuple,
    accuracy: number
}){
    const circleRef = useRef(null);
    const map = useMap();
    useEffect(() => {
        if(circleRef.current){
            map.fitBounds((circleRef.current as CircleType).getBounds());
        }
    }, [map])
    return(
        <Circle ref = {circleRef} center = {flyCoords} radius = {accuracy/* unit: meter */} fillColor = "blue"/>
    );
}